import styled from 'styled-components'

export const LayerWrapper = styled.div`
  position: absolute;
  z-index: 0;
  width: 100%;
  height: 100%;
  opacity: 0.8;
  top: 0;
  left: 0;
  background: #00000096;
  animation: appear 0.3s linear forwards;
  pointer-events: none;
  @keyframes appear {
    0% {
      opacity: 0;
    }
    100% {
      opacity: 0.8;
    }
  }
`
